import { cssUrlValue } from "@/utils/cssUrl";

type Props = {
  logoSrc: string;
  logoAlt: string;
  schoolName: string;
  /** Optional tenant-provided login background. */
  heroImageSrc?: string;
};

export function LoginBrandingPanel({
  logoSrc,
  logoAlt,
  schoolName,
  heroImageSrc,
}: Props) {
  const heroStyle = heroImageSrc
    ? {
        backgroundImage: `linear-gradient(rgba(255,255,255,0.35), rgba(255,255,255,0.35)), url("${cssUrlValue(heroImageSrc)}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : undefined;

  return (
    <section className="login-branding" style={heroStyle}>
      <div
        className={
          heroImageSrc
            ? "login-brand-content login-brand-content--backed"
            : "login-brand-content"
        }
      >
        <img
          src={logoSrc}
          alt={logoAlt}
          className="login-logo"
          loading="eager"
          decoding="async"
        />
        <div className="login-brand-copy">
          <h1>{schoolName}</h1>
          <p>Excellence in Education Management</p>
        </div>
      </div>
    </section>
  );
}
